import { render } from "./OWidgetTable.vue?vue&type=template&id=2182f64d"
import script from "./OWidgetTable.vue?vue&type=script&lang=js"
export * from "./OWidgetTable.vue?vue&type=script&lang=js"

import "./OWidgetTable.vue?vue&type=style&index=0&id=2182f64d&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__